import { type ChangeEvent } from 'react';
import { useFormContext, useController } from 'react-hook-form';

// Import types
import type { AgreementsType } from 'types/api/agreements';

export const useAgreementsFields = (name: string, agreements: AgreementsType) => {
	const { control } = useFormContext();

	const obligatory = agreements.filter((el) => el.obligatory);

	const { field, fieldState } = useController({
		name,
		control,
		rules: {
			validate: (value) => {
				const isValid = obligatory.every(({ version }) => value.includes(version.id));
				return isValid || 'agreements_validation_required';
			}
		}
	});

	const onChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
		const agreements = [...field.value];
		agreements[index] = e.target.checked ? +e.target.value : null;
		field.onChange(agreements);
	};

	return { field, fieldState, onChange };
};
